// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core from "@material-ui/core";
import * as Intl_Utils$DvmAdminFrontendFr from "../../../../../../intl/Intl_Utils.bs.js";
import * as Theme_Colors$DvmAdminFrontendFr from "../../../../../../theme/Theme_Colors.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../../../../context/user/User_Context.bs.js";
import * as App_Typography$DvmAdminFrontendFr from "../../../../../../common/App_Typography.bs.js";
import * as App_LabeledText$DvmAdminFrontendFr from "../../../../../../common/components/App_LabeledText.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../../../../common/types/App_Types_Result.bs.js";
import * as Messages_Flash_Search$DvmAdminFrontendFr from "../../../../../../intl/messages/flash/Messages_Flash_Search.bs.js";
import * as Messages_Orders_Derogate$DvmAdminFrontendFr from "../../../../../../intl/messages/orders/Messages_Orders_Derogate.bs.js";
import * as Order_Detail_Bonus_Derogate_Create_Api$DvmAdminFrontendFr from "./Order_Detail_Bonus_Derogate_Create_Api.bs.js";

function Order_Detail_Bonus_Derogate_Action_Info(Props) {
  var action = Props.action;
  var actionType = Props.actionType;
  var actionId = Props.actionId;
  var orderType = Props.orderType;
  var actionFetch = Props.actionFetch;
  var setActionFetch = Props.setActionFetch;
  var displayAmounts = Props.displayAmounts;
  var intl = ReactIntl.useIntl();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = match[0];
  var userManager = match$1.userManager;
  var selectedRole = match$1.selectedRole;
  var match$2 = React.useState(function () {
        
      });
  var setActionInfo = match$2[1];
  var actionInfo = match$2[0];
  React.useEffect((function () {
          Curry._1(setActionInfo, (function (param) {
                  
                }));
        }), [actionType]);
  React.useEffect((function () {
          Belt_Option.mapWithDefault(action, App_Types_Result$DvmAdminFrontendFr.mapWithDefault(actionFetch, undefined, (function (x) {
                      Belt_Option.mapWithDefault(x, undefined, (function (action) {
                              Curry._1(setActionInfo, (function (param) {
                                      var tmp;
                                      switch (actionType) {
                                        case "budget" :
                                            tmp = "budget";
                                            break;
                                        case "perf" :
                                            tmp = "perf";
                                            break;
                                        case "repr" :
                                            tmp = "repr";
                                            break;
                                        case "stoc" :
                                            tmp = "stoc";
                                            break;
                                        default:
                                          tmp = "budget";
                                      }
                                      return {
                                              actionType: tmp,
                                              actionId: action.actionID,
                                              actionIdLabel: action.actionLabel,
                                              budget: action.budgetTypes,
                                              actionBonusValue: action.bonusAmount,
                                              actionBonusPercentage: action.bonusAmount,
                                              actionCalcMethod: action.calcMethod,
                                              resultBonusPaid: undefined
                                            };
                                    }));
                            }));
                    })), (function (action) {
                  Curry._1(setActionInfo, (function (param) {
                          return action;
                        }));
                }));
        }), [
        action,
        actionFetch
      ]);
  React.useEffect((function () {
          if (Belt_Option.isNone(action)) {
            Order_Detail_Bonus_Derogate_Create_Api$DvmAdminFrontendFr.fetchOneAction(userManager, setActionFetch, selectedRole, actionId, orderType);
          }
          
        }), [actionId]);
  var actionInfo$1 = function (param) {
    return Belt_Option.getWithDefault(actionInfo, {
                actionType: "budget",
                actionId: "-",
                actionIdLabel: undefined,
                budget: undefined,
                actionBonusValue: undefined,
                actionBonusPercentage: undefined,
                actionCalcMethod: undefined,
                resultBonusPaid: undefined
              });
  };
  var tmp;
  var exit = 0;
  if (orderType !== 11 && orderType !== 0) {
    tmp = undefined;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = actionType === "budget" ? ({
          backgroundColor: Theme_Colors$DvmAdminFrontendFr.grayLight3,
          color: Theme_Colors$DvmAdminFrontendFr.grayDark1
        }) : undefined;
  }
  var tmp$1 = {
    children: null,
    container: true,
    item: true
  };
  if (tmp !== undefined) {
    tmp$1.style = Caml_option.valFromOption(tmp);
  }
  var tmp$2;
  var exit$1 = 0;
  if (orderType !== 11 && orderType !== 0) {
    tmp$2 = null;
  } else {
    exit$1 = 1;
  }
  if (exit$1 === 1) {
    tmp$2 = React.createElement(Core.Grid, {
          children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                label: Messages_Orders_Derogate$DvmAdminFrontendFr.budgetDero,
                children: Belt_Option.getWithDefault(actionInfo$1(undefined).budget, "-")
              }),
          item: true
        });
  }
  var tmp$3;
  if (displayAmounts) {
    var match$3 = Belt_Option.getWithDefault(actionInfo$1(undefined).actionCalcMethod, "");
    var tmp$4;
    switch (match$3) {
      case "AMOUNT" :
          tmp$4 = Belt_Option.mapWithDefault(actionInfo$1(undefined).actionBonusValue, "-", (function (eta) {
                  return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, eta);
                }));
          break;
      case "PERCENTAGE" :
          tmp$4 = Belt_Option.mapWithDefault(actionInfo$1(undefined).actionBonusPercentage, "-", (function (param) {
                  return Intl_Utils$DvmAdminFrontendFr.formatPercent(intl, param);
                }));
          break;
      default:
        tmp$4 = "-";
    }
    tmp$3 = React.createElement(React.Fragment, undefined, React.createElement(Core.Grid, {
              children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                    label: Messages_Orders_Derogate$DvmAdminFrontendFr.deroAmountAction,
                    children: tmp$4
                  }),
              item: true
            }), React.createElement(Core.Grid, {
              children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                    label: Messages_Orders_Derogate$DvmAdminFrontendFr.derogateBonusAmountPaid,
                    children: Belt_Option.mapWithDefault(actionInfo$1(undefined).resultBonusPaid, "-", (function (x) {
                            return Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, x);
                          }))
                  }),
              item: true
            }));
  } else {
    tmp$3 = null;
  }
  return React.createElement(Core.Grid, tmp$1, React.createElement(Core.Grid, {
                  children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                        gutterBottom: true,
                        style: {
                          fontWeight: "600"
                        },
                        children: intl.formatMessage(Messages_Orders_Derogate$DvmAdminFrontendFr.derogateActionInfo),
                        variant: "h5"
                      }),
                  item: true
                }), React.createElement(Core.Grid, {
                  children: null,
                  container: true,
                  justifyContent: "space-evenly",
                  spacing: 1
                }, tmp$2, (
                  orderType !== 11 && orderType !== 0 ? false : actionType === "budget"
                ) ? null : React.createElement(React.Fragment, undefined, React.createElement(Core.Grid, {
                            children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                  label: Messages_Flash_Search$DvmAdminFrontendFr.flashMarketingActionID,
                                  children: actionInfo$1(undefined).actionId
                                }),
                            item: true
                          }), React.createElement(Core.Grid, {
                            children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                  label: Messages_Flash_Search$DvmAdminFrontendFr.bonusLabel,
                                  children: Belt_Option.getWithDefault(actionInfo$1(undefined).actionIdLabel, "-")
                                }),
                            item: true
                          })), tmp$3));
}

var Form;

var Api;

var Types;

var make = Order_Detail_Bonus_Derogate_Action_Info;

export {
  Form ,
  Api ,
  Types ,
  make ,
}
/* react Not a pure module */
